export default "__VITE_ASSET__BFXX$uub__"